import { useMemo } from "react";
import { parseInlineMarkdown } from "../../functions/inlineMarkdown";

/**
 * Props for the InlineMarkdown component
 * @property {string} [value] - The markdown string to parse and render
 */
export interface InlineMarkdownProps {
  value?: string;
}

/**
 * Renders a string with limited inline markdown constructs as formatted React content.
 *
 * Features:
 * - Bold: `**text**`
 * - Italic: `*text*`
 * - Bold and italic: `***text***`
 * - Highlight: `==text==`
 * - Inline code: `` `text` ``
 * - Memoized rendering for performance
 * - Passes through plain strings with no overhead
 *
 * @example
 * <InlineMarkdown value="Save **now** or `discard`" />
 */
export const InlineMarkdown = ({ value = "" }: InlineMarkdownProps) => {
  const content = useMemo(() => parseInlineMarkdown(value), [value]);
  return <>{content}</>;
};
